<template>
  <div class="container">

    <h4>{{user.name}} {{user.last_name}}</h4>

    <form-table-items :items="items"/>

    <b-row class="pt-3 mt-3">
      <pagination :meta="pagination" :on-change-page="changeProductsPage"/>
    </b-row>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import FormTableItems from "./FormTableItems.vue";
import Pagination from "../Pagination.vue";

export default {
  name: "UserFormFills",
  components: {Pagination, FormTableItems},
  data() {
    return {
      pagination: {},
      items: {},
      user: {}
    }
  },
  computed: {
    ...mapGetters({
      userId: "User/getUserId",
    })
  },
  methods: {
    changeProductsPage(page) {
      this.loadItems(page)
    },
    loadItems(page = 1) {
      let form = {
        user_id: this.$route.params.user,
        page: page
      }
      let req = this.$store.dispatch('Form/getUserFormFills', form)
      req.then(res => {
        let baseData = res.data.data;
        this.items = baseData.data
        this.pagination = baseData.meta
        this.user = baseData.user
      })
    }
  },
  mounted() {
    this.loadItems()
  }
}
</script>


<style scoped>

</style>